import type { PropsWithChildren } from 'react'
import { useAppSelector } from 'hooks/reduxHooks'
import { isSpoofed as isSpoofedSelector } from 'selectors/isSpoofed'
import SalesCopilotWorkspace from 'components/App/SalesCopilot/SalesCopilotWorkspace'

// Sales Co-Pilot chrome for spoofing agents: the launchpad on the left everywhere but checkout, and the "close the sale" sidebar on the right once dates are chosen or checkout starts.
function SalesCopilotLayout({ children }: PropsWithChildren) {
  const isSpoofed = useAppSelector(isSpoofedSelector)

  if (!isSpoofed) return <>{children}</>
  return <SalesCopilotWorkspace>{children}</SalesCopilotWorkspace>
}

export default SalesCopilotLayout
